/**
 * EN locale scaffold.
 *
 * NOT: TR full set'in birebir EN çevirisi henüz yapılmadı. Aşağıdaki anahtarlar
 * sık kullanılan üst-seviye yerlerin İngilizce karşılıkları. Eksik anahtarlar
 * `t()` tarafından otomatik fallback ile dot-path olarak gösterilir; bu da
 * geliştirici uyarısı olarak console'a warn düşer.
 *
 * Tam EN parite için katalogu genişletin. Çevirinin organize tutulması için
 * tr.js'deki en üst seviyedeki anahtar yapısını koruyun.
 */
export const en = {
  common: {
    brand: 'DEKOSTA',
    email: 'Email',
    password: 'Password',
    save: 'Save',
    cancel: 'Cancel',
    next: 'Next',
    back: 'Back',
    loading: 'Loading...',
    error: 'Error',
    playerFallback: 'Player',
  },
  auth: {
    login: {
      title: 'Sign in',
      googleContinue: 'Continue with Google',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
    },
    register: {
      subtitle: 'Create your collection account',
      hintMinChars: 'Min 8 characters',
      submit: 'Create account',
      submitLoading: 'Creating...',
      toastEmailRequired: 'Email is required.',
      toastPasswordMin: 'Password must be at least 8 characters.',
      toastAccountReady: 'Welcome!',
      registerFailedFallback: 'Registration failed.',
      freeNote: 'Free to join. No in-app purchase.',
      hasAccount: 'Already have an account?',
    },
    unexpectedResponse: 'Unexpected server response.',
    sessionVerifyFailed: 'Session could not be verified.',
  },
  character: {
    pageTitle: 'Character',
    sectionCollectionCard: 'Collection card',
    starAriaLabel: '{stars} stars',
  },
  profile: {
    title: 'Profile',
    sectionProfile: 'Profile',
    navAppearance: 'Appearance',
    navAchievements: 'Achievements',
    navFriends: 'Friends',
    navAccount: 'Account',
  },
  friends: {
    loadError: 'Could not load friends.',
    usernameRequired: 'Username is required.',
    requestSent: 'Friend request sent.',
    remove: 'Remove',
  },
};
